import syncArticle from './syncArticle'
import saveArticle from './saveArticle'
import restoreData from './restoreData'
import myGallery from './myGallery'
import growthChart from './growthChart'
import ImportArticle from './importArticle'

export default{
  syncArticle,
  saveArticle,
  restoreData,
  myGallery,
  growthChart,
  ImportArticle
}


// WEBPACK FOOTER //
// ./src/components/dialog/index.js